import Select from 'antd/es/select';
import style from '../Overview.module.css';
import {
  clusterIconsDict,
  SmallTableIcon,
} from '../../../utils/customIcons.jsx';
import { Button, Tooltip } from 'antd';
import CircleGauge from '../../../components/UI/CircleGauge.jsx';
import { CloseOutlined } from '@ant-design/icons';
import { useUnit } from 'effector-react';
import { resetNicheClusters } from '../../../models/overviewModel/index.js';

const questionLegendDict = {
  unresolved: 'Нерешенные вопросы',
  in_progress: 'На рассмотрении',
  resolved: 'Решенные вопросы',
};

export default function OverviewClusterCard(props) {
  const { title, cards, cardClick, field, selects, niche, nicheCluster } =
    props;
  const resetNiche = useUnit(resetNicheClusters);

  return (
    <div
      className={style.cluster_cards_cnt}
      onClick={cardClick}
      data-category={field}
      data-subcategory={cards[0].subCategory}
      data-type="card"
    >
      <div className={style.cluster_cards_header}>
        <span className={style.cluster_cards_header_title}>{title}</span>
        <div className={style.cluster_cards_header_selects}>
          {(!!niche || !!nicheCluster) && (
            <Button
              icon={<CloseOutlined />}
              size={'small'}
              onClick={() => resetNiche()}
            />
          )}
          {selects.map((select, index) => {
            return (
              <Select
                key={`${title}-select-${index}`}
                options={select.options}
                defaultValue={select.value}
                value={select.type === 'niche' ? niche : nicheCluster}
                onChange={select.onChange}
                size={'small'}
                style={{ width: 160 }}
              />
            );
          })}
        </div>
      </div>
      <div className={style.cluster_subcards_cnt}>
        {cards.map((item) => {
          if (item.subCategory === 'development_program') {
            return <DevStrategyCard card={item} key={item.title} />;
          } else if (item.subCategory === 'top_problems') {
            return <ProblemsCard card={item} key={item.title} />;
          }
        })}
      </div>
    </div>
  );
}

function DevStrategyCard({ card }) {
  return (
    <div className={style.cluster_subcard}>
      <div className={style.cluster_subcard_title}>
        <span>{card.title}</span>
      </div>
      <div className={style.cluster_dev_items_cnt}>
        {card.items.map((item, idx) => (
          <div
            className={style.cluster_dev_item}
            key={idx}
            onClick={() => card.infoModal(item.type)}
          >
            <span className={style.cluster_dev_item_title}>{item.title}</span>
            <div className={style.cluster_dev_item_icon_cnt}>
              {clusterIconsDict[item.type]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ProblemsCard({ card }) {
  return (
    <div className={style.cluster_subcard}>
      <div className={style.cluster_subcard_title}>
        <span>{card.title}</span>
        {card.infoModal && !card.noButton ? (
          <Tooltip title="Просмотр таблицы" placement="bottom">
            <Button
              size={'small'}
              ghost
              className={style.modal_button}
              icon={SmallTableIcon}
              onClick={() => card.infoModal(card.subCategory)}
            />
          </Tooltip>
        ) : (
          ''
        )}
      </div>
      <div className={style.cluster_problems_blocks_cnt}>
        <div className={style.cluster_problems_v_block}>
          {Object.entries(card.questions).map(([key, count]) => (
            <div
              className={style.cluster_problems_v_block_item}
              style={{ '--question-color': `var(--${key})` }}
            >
              <span>{count}</span>
            </div>
          ))}
        </div>
        <div className={style.cluster_problems_gauges_cnt}>
          {card.progressItems?.map((i, idx) => (
            <CircleGauge
              value={i.current}
              max={i.total}
              label={i.title}
              key={idx}
            />
          ))}
        </div>
      </div>
      <div className={style.cluster_problems_legend_cnt}>
        {Object.keys(card.questions).map((key) => (
          <div className={style.cluster_problems_legend_item}>
            <div
              className={style.cluster_problems_legend_item_dot}
              style={{ '--question-color': `var(--${key})` }}
            />
            <span className={style.cluster_problems_legend_item_title}>
              {questionLegendDict[key]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
